import { SvgIcon } from '@mui/material';

const Sunday = props => (
  <SvgIcon width='33.17' height='35.934' viewBox='0 0 33.17 35.934' {...props}>
    <g id='Group_184' data-name='Group 184' transform='translate(0 0)'>
      <g id='Group_183' data-name='Group 183' transform='translate(0 0.001)'>
        <path
          id='Path_93'
          data-name='Path 93'
          d='M32.36,3.574a2.762,2.762,0,0,0-1.954-.809H26.259V1.382a1.382,1.382,0,1,0-2.764,0V2.765H9.675V1.382a1.382,1.382,0,0,0-2.765,0V2.765H2.765A2.763,2.763,0,0,0,0,5.528V33.17a2.763,2.763,0,0,0,2.765,2.764H30.406a2.765,2.765,0,0,0,2.765-2.764V5.528a2.763,2.763,0,0,0-.81-1.955M8.052,26.353a6.422,6.422,0,0,1-2.7-.628l.478-1.788a4.148,4.148,0,0,0,2.255.724c.6,0,.948-.18.948-.574,0-.256-.212-.416-.66-.543l-1.149-.33C6,22.862,5.381,22.244,5.381,21.191c0-1.277,1-2.277,2.937-2.277a6.5,6.5,0,0,1,2.629.575l-.575,1.692a4.819,4.819,0,0,0-2.139-.575c-.555,0-.788.181-.788.479,0,.234.149.351.531.468l1.247.362c1.352.4,1.893,1.064,1.893,2.044,0,1.4-1.2,2.394-3.064,2.394m11.1-3.246A3.2,3.2,0,0,1,15.7,26.353a3.113,3.113,0,0,1-3.427-3.246v-4.1h2.043v3.959c0,.947.479,1.511,1.384,1.511a1.338,1.338,0,0,0,1.4-1.523V19.009H19.15Zm8.672,3.139H26.055l-3.288-3.98v3.98H20.724V19.009h1.767L25.779,23V19.009h2.043Zm2.584-15.189H2.765V5.528H6.911V6.911a1.382,1.382,0,0,0,2.765,0V5.528H23.5V6.911a1.382,1.382,0,1,0,2.764,0V5.528h4.147Z'
          transform='translate(0 0)'
          fill='#dc0032'
        />
      </g>
    </g>
  </SvgIcon>
);

export default Sunday;
